// i18next reserved option names. If a `warningParams` entry uses one of these,
// it would silently override i18next's behaviour rather than be interpolated:
// `count` flips lookup to the plural form; `defaultValue` clobbers our stored
// fallback; `context`/`lng`/`ns` repoint the lookup. The dashboard rejects
// these on the read path and the schema rejects them on save.
const RESERVED = new Set<string>([
    "defaultValue",
    "count",
    "ordinal",
    "context",
    "replace",
    "lng",
    "lngs",
    "fallbackLng",
    "ns",
    "keySeparator",
    "nsSeparator",
    "returnObjects",
    "joinArrays",
    "postProcess",
    "postProcessPassResolved",
    "interpolation",
    "skipInterpolation",
    "transSupportBasicHtmlNodes",
    "transKeepBasicHtmlNodesFor",
]);

/**
 * Returns whether a param name is reserved by i18next translation options.
 * Call this when validating interpolation params to avoid option-key collisions.
 */
export function isReservedI18nextOptionKey(name: string): boolean {
    return RESERVED.has(name);
}

/**
 * Returns all param keys that collide with reserved i18next options.
 * Use this before interpolation or persistence to prevent params from changing
 * i18next lookup behavior instead of being treated as template values.
 */
export function findReservedWarningParamKeys(params: Record<string, unknown> | null | undefined): string[] {
    return params ? Object.keys(params).filter(isReservedI18nextOptionKey) : [];
}
